import SearchGroupModalView from "../guests/searchGroupModal.html";

import _ from 'lodash';

angular.module('events')

    .controller('EventGroupsListCtrl', ['event', '$scope', '$rootScope', '$uibModal', '$filter', 'Restangular', '$stateParams', '$sce', 'treeService', '$http', function (event, $scope, $rootScope, $uibModal, $filter, Restangular, $stateParams, $sce, treeService, $http) {

        var event_id = parseInt($stateParams.id);

        $rootScope.title = event.name + " - " + $filter('translate')('groups.title');
        $rootScope.breadcrumb = [
            { title: $filter('translate')('events.title'), url: "events.list" },
            { title: event.name, url: "events.edit({ id: " + event_id + " })" },
            { title: $filter('translate')('groups.title') }
        ];

        $scope.search = {
            name: "",
            hasSearched: false,
            hasFilteredGroups: false,
            groupsNamesArray: [],
            listGroupsIds: [],
            listPositionsIds: []
        }

        $scope.getvalueArray = function (item) {
            let result = [];
            for (var i = 0; i < item; i++) {
                result.push(i);
            }
            return result;
        }

        $scope.loadData = function () {
            Restangular.all('EventsGroups').customGET("GetGroupsByEvent", { event_id: event_id }).then(function (results) {
                $scope.eventGroup = results;
                $scope.eventGroup.event_id = event_id;
                if ($scope.eventGroup != null && $scope.eventGroup.groupsIds != null && $scope.eventGroup.groupsIds != "") {
                    $scope.search.listGroupsIds = $.map($scope.eventGroup.groupsIds.split(','), function (value) {
                        return parseInt(value, 10);
                    });
                }
                if ($scope.eventGroup != null && $scope.eventGroup.positionsIds != null && $scope.eventGroup.positionsIds != "") {
                    $scope.search.listPositionsIds = $.map($scope.eventGroup.positionsIds.split(','), function (value) {
                        return parseInt(value, 10);
                    });
                }
                $http({
                    method: 'get',
                    url: (window as any).CONFIG.api_url + 'EventsGroups/GetListGroupsByEventAndPositions',
                    params: { event_id: event_id }
                }).then(function (resultsGroups, status, headers, config) {
                    var data = treeService.groups(resultsGroups.data, null);
                    $scope.groups = data;

                    //Seleccionamos los grupos que ya están añadidos.
                    //Habria que borrarlo pero así no aparece el texto....
                    angular.forEach(data, function (item) {
                        var index = ($scope.search.listGroupsIds != null && typeof ($scope.search.listGroupsIds) !== 'undefined' ? $scope.search.listGroupsIds.indexOf(item.id) : -1);

                        if (index > -1) {
                            item.checked = true;
                            item.forceChecked = true;
                        }

                        //comprobamos si tiene alguna posicion seleccionada.
                        let seleccionar = false;
                        angular.forEach(item.FK_positions_groups, function (position) {
                            if (position.selected) seleccionar = true;
                        });
                    });
                });


            });
        }

        $scope.loadData();

        $scope.filterGroups = function () {
            let $modalInstance = $uibModal.open({
                animation: true,
                template: SearchGroupModalView,
                size: "lg",
                controller: "SearchGroupModalCtrl",
                resolve: {
                    preselect: function () {
                        return false;
                    },
                    event_id: function () {
                        return event_id;
                    },
                    is_filter: function () {
                        return false;
                    },
                    listGroupsIds: function () {
                        return $scope.search.listGroupsIds;
                    },
                    listPositionsIds: function () {
                        return $scope.search.listPositionsIds;
                    }
                }
            });

            // Response del modal
            $modalInstance.result.then(function (groups) {
                $scope.search.hasFilteredGroups = groups.ids.length > 0;
                $scope.search.groupsNamesArray = _.chain(groups.groups)
                    .filter(function (group) { return _.some(groups.ids, function (id) { return id == group.id; }); }).value();

                $scope.eventGroup.groupsIds = _.chain(groups.ids).reduce(function (memo, group) { return (memo == "" ? group : memo + "," + group); }, "").value();
                $scope.search.listGroupsIds = groups.ids;
                $scope.search.listPositionsIds = groups.listPositions;
                $scope.eventGroup.positionsIds = _.chain(groups.listPositions).reduce(function (memo, positionId) { return (memo == "" ? positionId : memo + "," + positionId); }, "").value();//groups.listPositions;
                $scope.save();

            }, function () {
                console.info('Modal dismissed at: ' + new Date());
                if (!$scope.$$phase) $scope.$apply();
            });
        };

        $scope.trustAsHtml = function (string) {
            return $sce.trustAsHtml(string);
        };

        $scope.save = function () {
            if (angular.isDefined($scope.eventGroup.id) && $scope.eventGroup.id != null) {
                $scope.eventGroup.put().then(function (result) {
                    if (angular.isDefined(result.id)) {
                        toastr.success($filter('translate')('events.groups.edit_success'));
                        $scope.loadData();
                    }
                });
            } else {
                var postGroups = { event_id: $stateParams.id, groupsIds: $scope.eventGroup.groupsIds, positionsIds: $scope.eventGroup.positionsIds };

                Restangular.all('EventsGroups').post(postGroups).then(function (result) {
                    if (angular.isDefined(result.id)) {
                        toastr.success($filter('translate')('events.groups.add_success'));
                        $scope.loadData();
                    }
                });
            }
        }

    }]);